import 'firebase/performance';
import firebase from './firebase';
export default firebase.performance();
